<template>
  <div class="synonym-list">
    <div class="var-title">
      <h4 class="synonym-title">{{ $t("synonyms.title") }}</h4>
      <div class="actions" v-if="!isDemo">
        <div
          v-if="!localSynonym"
          @click="onConvertGlobalToLocal"
          class="header-icons"
          :tooltip="$store.state.showTooltips == true ? $t('synonyms.convert-to-standard-tooltip') : ''"
          tooltip-placement="left"
        >
          <i class="fa-light fa-exchange-alt"></i>
        </div>
        <div class="header-icons" v-else @click="revealConvertToGlobalForm = !revealConvertToGlobalForm">
          <div
            v-show="!revealConvertToGlobalForm"
            :tooltip="$store.state.showTooltips == true ? $t('synonyms.convert-to-template-tooltip') : ''"
            tooltip-placement="left"
          >
            <i class="fa-light fa-exchange-alt"></i>
          </div>
          <div v-show="revealConvertToGlobalForm">
            <i class="fa-light fa-times"></i>
          </div>
        </div>
      </div>
    </div>

    <form class="convert-form" @submit.stop.prevent v-if="revealConvertToGlobalForm">
      <!-- <input ref="inputField" type="text" :placeholder="'Convert to global synonym'" v-model="globalSynName"> -->
      <custom-input
        :inputType="'text'"
        v-model="globalSynName"
        :name="'ConvertToGlobal'"
        :label="'Convert to global synonym'"
        :placeholder="'Enter a name'"
        :focusInputField="true"
      />
      <span v-if="invalidName" class="text-danger">
        {{ $t("template-syns.duplicate-name-err") }}
        <br />
      </span>
      <span v-if="!invalidChars" class="text-danger">
        {{ $t("template-syns.invalid-name-err") }}
        <br />
      </span>
      <button
        type="submit"
        class="btn btn-primary"
        :disabled="invalidName || !invalidChars || globalSynName == ''"
        @click="convertLocalToGlobal"
      >
        {{ $t("synonyms.convert") }}
      </button>
    </form>

    <div v-else class="local-synonym">
      <form class="d-flex add-synonym-form" @submit.stop.prevent="addSynonym" :class="{ disabled: !converted && !localSynonym || invalidParenthesis}">
        <input
          ref="inputField"
          type="text"
          :placeholder="placeholderText"
          v-model="newSynonym.name"
          :disabled="!converted && !localSynonym"
        />
        <button type="submit" class="new-synonym" :disabled="!converted && !localSynonym || invalidParenthesis">+</button>
      </form>
      <span class="text-small text-danger parenthesis-error" v-if="invalidParenthesis">{{$t('synonyms.parentheses-err')}}</span>
      <div class="list-wrapper custom-scrollbar-light" :class="{'list-height-local': localSynonym, 'list-height-global': !localSynonym, }">
        <div
          class="synonym-single"
          v-for="(synonym, index) in synonymList"
          :key="index"
          :class="{ disabled: !converted && !localSynonym }"
        >
        
          <input v-if="localSynonym" type="text" v-model="synonymList[index]" @change="editSyn" />
          <input v-else type="text" v-model="synonymList[index]" @change="editSyn" :disabled="!converted" />

          <span class="text-danger text-small" v-show="invalidParenthesisInList.includes(index)" :tooltip="$t('synonyms.parentheses-err')" tooltip-placement="left"><i class="fa-light fa-exclamation-circle"></i></span>
          <div
            v-if="(converted && !localSynonym) || localSynonym"
            class="trashcan"
            @click="removeSynonym(synonym, index)"
          >
          <i class="fa-light fa-trash"></i>
          </div>
          <div v-else class="synonym-example">{{ examples[index] }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import ConfirmModal from "@/components/modals/ConfirmModal";
export default {
  name: "SynonymList",
  data() {
    return {
      synonymList: [],
      newSynonym: {
        name: this.selectedText ? this.selectedText : "",
      },
      placeholderText: this.$t("synonyms.placeholder"),
      converted: false,
      globalSynName: "",
      revealConvertToGlobalForm: false,
      duplicateName: false,
    };
  },
  props: {
    synonymInstance: { type: Object },
    selectedText: String,
    localSynonym: Boolean,
    examples: Array,
    aiSuggestions: Array,
  },

  methods: {
    addSynonym(evt) {
      evt.preventDefault();
      this.synonymList.push(this.newSynonym.name);
      this.newSynonym.name = "";
      this.$emit("syn-list", this.mergedSyntax);
      this.placeholderText = this.$t("synonyms.placeholder");
    },
    removeSynonym(synonym, index) {
      this.synonymList.splice(index, 1);
      this.$emit("syn-list", this.mergedSyntax);
    },
    editSyn(index) {
      this.$emit("syn-list", this.mergedSyntax);
    },
    convertLocalToGlobal(evt) {
      evt.preventDefault();
      this.duplicateName = false;
      const globalSynonym = {
        name: this.globalSynName,
        synonyms: this.synonymList,
      };
      this.$store.state.template.globalSynonyms.push(globalSynonym);
      this.$nextTick(() => {
        this.$emit("converted-to-global", globalSynonym);
        this.revealConvertToGlobalForm = !this.revealConvertToGlobalForm;
      });
    },
    convertGlobalToLocal(keepExamples) {
      this.converted = true;
      let synArr = [];
      if (keepExamples) {
        this.examples.forEach((syn, index) => {
          this.synonymList[index] = syn;
          synArr.push(syn);
        });
      } else {
        this.synonymInstance.synonyms.forEach((syn) => {
          synArr.push(syn);
        });
      }
      this.$emit("syn-list", synArr);
      this.$emit("converted-to-local");
    },
    onConvertGlobalToLocal() {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("synonyms.keep-format"),
          description: this.$t("synonyms.keep-format-description"),
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no"),
          onConfirm: () => {
            this.convertGlobalToLocal(true);
          },
          onCancel: () => {
            this.convertGlobalToLocal(false);
          },
        },
        { width: 350, height: "auto" },
      );
    },
    onAddFormats() {
      this.$emit("format-syn");
    },
  },

  computed: {
    mergedSyntax() {
      //    let names = this.synonymList.map(s=> s.name);
      let names = this.synonymList;
      return names;
    },
    cleaned() {
      let cleaned = this.synonymInstance.values.split("|");
      return cleaned;
    },
    invalidName() {
      return this.$store.state.template.globalSynonyms.some((syn) => syn.name == this.globalSynName);
    },
    invalidChars() {
      return this.globalSynName !== "" ? /^[ÆØÅæøå"'a-z0-9\-\\ ]+$/i.test(this.globalSynName) : true;
    },
    
    isDemo(){
        return this.$store.state.editorIsDemoVersion
    },
    
    invalidParenthesis(){
      const openings = this.newSynonym.name.match(/\(/g) || []
      const closings = this.newSynonym.name.match(/\)/g) || []
      return openings.length != closings.length
    },

    invalidParenthesisInList(){
      let invalids = []
      this.synonymList.forEach((syn, index) => {
      const openings = syn.match(/\(/g) || []
      const closings = syn.match(/\)/g) || []
      if(openings.length != closings.length){invalids.push(index)} 
      } )
      return invalids
    }

  },
  watch:{
    invalidParenthesisInList:{
      handler: function(){
        this.$emit("paranthesis-status", this.invalidParenthesisInList.length > 0)
      }
    }
  },
  created() {
    if (this.synonymInstance && this.localSynonym == true) {
      let synonymsInArray = this.synonymInstance.values.split("|");
      synonymsInArray.forEach((syn) => {
        this.synonymList.push(syn);
        this.$emit("syn-list", this.mergedSyntax);
      });
    } else if(this.aiSuggestions.length > 0){ 
      this.synonymList.push(this.selectedText)
      this.newSynonym.name = ""

      this.aiSuggestions.forEach((suggestion) => {
        this.synonymList.push(suggestion);
      });
      this.$emit("syn-list", this.mergedSyntax);
    } else if (this.localSynonym !== true) {
      // if the synonym that is opened is a "templatesynonym"
      this.synonymInstance.synonyms.forEach((syn) => {
        this.synonymList.push(syn);
      });
    }
  },
  mounted() {
    this.$refs.inputField.focus();
  },
  components: {
    CustomInput,
  },
};
</script>

<style lang="less">
.synonym-list {
  
  .new-synonym {
    font-size: 18px;
    font-weight: 400;
    color: rgb(117, 117, 117);
    border: none;
    background-color: transparent;
    border-radius: 50%;
    padding: 0px 6px;
    grid-column-start: 1;
    grid-row-start: 1;
  }

  form.add-synonym-form {
    margin: 10px 20px 0;
    justify-content: space-between;
    border-bottom: 1px solid #3d464a1e;
    &:focus-within {
      border-bottom: 1px solid #3d464a;
    }
  }
  form.convert-form {
    margin: 0 20px 10px;
    button {
      margin-top: 10px;
    }
  }
  .highlight-err{
    color: red !important;
  }
  .parenthesis-error{
    padding: 0 20px;
  }

  .local-synonym input {
    // width: 240px;
    flex: 1;
    padding: 10px 0;
    border: none;
    &:focus {
      outline: 0;
      + .new-synonym {
        color: var(--orange-web);
      }
    }
  }
  .new-synonym {
    transition: 0.2s;
    &:focus {
      outline: 0 !important;
      color: var(--orange-web);
      // font-weight: 900;
    }
  }
  .list-height-global{
    max-height: calc(100vh - 470px);
  }
  .list-height-local{    
    max-height: calc(100vh - 227px);
  }
  .list-wrapper {
    overflow: auto;
    padding: 10px 0 20px;
    .synonym-single {
      transition: 0.5s;
      margin: 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: "Roboto", sans-serif;
      font-size: 14px;
      color: #3d464a;
      border-bottom: 1px solid #3d464a1e;
      input {
        padding: 10px 0;
        border: none;
        &:focus {
          padding-bottom: 10px;
        }
      }
      &:focus-within {
        border-bottom: 1px solid #3d464a;
      }
      .trashcan {
        margin-left: 4px;
        cursor: pointer;
        align-self: center;
      }
      .synonym-example {
        margin-left: 8px;
        padding: 0;
        max-width: 40%;
        white-space: nowrap;
        overflow-x: auto;
      }
    }
  }
  .header-icons {
    svg {
      margin: 0 2px;
    }
    text-transform: none;
  }

  .var-title {
    display: flex;
    justify-content: space-between;
    padding: 14px 20px;
    .actions {
      color: var(--charcoal);
      flex-direction: row;
      gap: 12px;
    }

    .synonym-title {
      color: var(--charcoal);
      margin-bottom: 0;
    }
  }

  .disabled {
    opacity: 0.5;
  }
}
</style>
